import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import reportWebVitals from './reportWebVitals';
import RouterPage from './Routerpage';
import { VerificationProvider } from './context/VerificationContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VerificationProvider>
    <RouterPage />
    </VerificationProvider>
  </React.StrictMode>
);


reportWebVitals();
